import { createFileRoute } from '@tanstack/react-router'
import { PasswordSection } from '@/routes/(private)/profile/-components/password-section'

export const Route = createFileRoute('/(private)/profile/security')({
	staticData: {
		breadcrumb: 'profile:nav.security'
	},
	component: AdminProfileSecurity
})

function AdminProfileSecurity() {
	return (
		<div className='flex w-full flex-col gap-8 p-8'>
			<PasswordSection />
		</div>
	)
}
